import OkTableConfigType from '@/@bya3/components/tables/ok-table/OkTableConfigType'
import { API_URL } from '@/constants/config'

const N8nPagesTableConfig: OkTableConfigType = {
  mode: 'remote',
  url: `${API_URL}/n8n-pages`,
  rowsPath: 'data',
  rowClickable: true,
  attachPageId: false,
  actionFirst: true,
  actions: [
    {
      label: 'forms.edit',
      eventName: 'edit',
      icon: 'EditIcon',
    },
    {
      label: 'forms.delete',
      eventName: 'delete',
      icon: 'Trash2Icon',
    },
    {
      label: 'n8n.history',
      eventName: 'history',
      icon: 'ListIcon',
    },
  ],
  columns: [
    {
      label: 'fields.id',
      field: 'id',
    },
    {
      label: 'page.name',
      field: 'page.page_name',
    },
    {
      label: 'n8n.start_at',
      field: 'start_at',
    },
    {
      label: 'n8n.expires_at',
      field: 'expires_at',
    },
    {
      label: 'n8n.post_count',
      field: 'post_count',
    },
    {
      label: 'n8n.status',
      field: 'status',
    },
    {
      label: 'n8n.execute_at',
      field: 'execute_at',
    },
    {
      label: 'n8n.telegram_chat_id',
      field: 'telegram_chat_id',
    },
  ],
  paginationOptions: {
    enabled: true,
  },
  sortOptions: {
    enabled: false,
  },
  filters: [
    {
      label: 'page.name',
      query: 'page_id',
      colLength: 4,
      type: 'autocomplete',
    },
    {
      label: 'n8n.status',
      query: 'status',
      colLength: 4,
      type: 'select',
      multiple: false,
      options: [
        { text: 'general.active', value: 1 },
        { text: 'general.inactive', value: 0 },
      ],
      optionsLabel: { keyLabel: 'text', valueLabel: 'value', translate: true },
    },
    {
      label: 'n8n.active',
      query: 'active',
      colLength: 4,
      type: 'select',
      multiple: false,
      options: [
        { text: 'general.yes', value: true },
        { text: 'general.no', value: false },
      ],
      optionsLabel: { keyLabel: 'text', valueLabel: 'value', translate: true },
    },
  ],
}

export default N8nPagesTableConfig
